export default __webpack_public_path__ + "static/media/dozingInTheBackSeat.93bacf83.mp3";